import React, { useEffect, useState } from 'react';
import { GetProcessPaymentJson } from '../services/PaymentService';
import AuthorizedPayment from '../components/AuthorizedPayment';

function AprovedPayment() {
    const [orderReferenceNumber, setOrderReferenceNumber] = useState(null);
    const [urlRedirect, setUrlRedirect] = useState('');
    const [totAmount, setTotAmount] = useState(0);

    const searchParams = React.useMemo(() => new URLSearchParams(window.location.search), []);
    const transactionId = searchParams.get('transactionId');
   
    useEffect(() => {
        console.log(transactionId);

        const fetchData = async () => {
            try {
                const data = await GetProcessPaymentJson(transactionId);
                setOrderReferenceNumber(data.orderReferenceNumber);
                setTotAmount(data.total || 0);
                setUrlRedirect(data.returnURL || '');
            } catch (error) {
                //console.error('Error fetching payment data:', error);
            }
        };

        fetchData();
    }, [searchParams, transactionId, urlRedirect]);

    useEffect(() => {
        if (urlRedirect) {
            const timer = setTimeout(() => {
                window.location.assign(urlRedirect);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [urlRedirect]);

    return (
        <div>
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
            <div className="bg-white p-9 ml-8 mr-8 rounded-xl shadow-md text-center w-auto max-w-[800px] h-auto max-h-[800px]">
                <AuthorizedPayment
                    orderReferenceNumber={orderReferenceNumber}
                    urlRedirect={urlRedirect}
                    orderAmount={totAmount}
                />
            </div>
        </div>
        </div>
    ); 
}

export default AprovedPayment;